export default __webpack_public_path__ + "static/media/penySuccess.c02b2ccd.png";